const state = {
  exportFlag: false,
  isHidden: false,
  exportCont: {}
};

const getters = {};

//actions
const actions = {
  getExportFlag({ commit, dispatch }, data) {
    commit('setExportFlag', data);
    return data;
  },
  getExportStatus({ commit, dispatch }, data) {
    commit('setExportStatus', data);
    return data;
  }
};

// mutations
const mutations = {
  setExportFlag(state, data) {
    state.exportFlag = data.exportFlag;
    if (data.exportFlag) {
      state.exportCont = data.exportCont;
    } else {
      state.exportCont = null;
    }
  },
  setExportStatus(state, data) {
    state.isHidden = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/exportTips.js